export default __webpack_public_path__ + "static/media/commands_search_instructions_dark.6c19d2c7.svg";